import { toJalaali } from 'jalaali-js';
import { toPersianNumber } from './persianNumber';

const weekDays = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];
const months = [
    'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
    'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
];

/**
 * Formats a Gregorian date string (YYYY-MM-DD) to Persian date string
 * Example: 2023-12-14 -> پنج‌شنبه ۲۳ آذر ۱۴۰۲
 */
export const formatPersianDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    const jDate = toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
    const dayOfWeek = date.getDay(); // 0 = Sunday

    return `${weekDays[dayOfWeek]} ${toPersianNumber(jDate.jd)} ${months[jDate.jm - 1]} ${toPersianNumber(jDate.jy)}`;
};

/**
 * Formats a Gregorian date string (YYYY-MM-DD) to simple Persian date string
 * Example: 2023-12-14 -> ۱۴۰۲/۰۹/۲۳
 */
export const formatSimplePersianDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    const jDate = toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());

    const y = toPersianNumber(jDate.jy);
    const m = toPersianNumber(String(jDate.jm).padStart(2, '0'));
    const d = toPersianNumber(String(jDate.jd).padStart(2, '0'));

    return `${y}/${m}/${d}`;
};
